
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Sentry from '@sentry/vue';
import { SapInvoice } from '@/api/model';
import { InvoiceApi } from '@/api';
import getConfiguration from '@/store/getConfiguration';

@Component
export default class DownloadInvoicePdf extends Vue {
  @Prop(Object)
  invoice!: SapInvoice;

  s3Url = '';

  isLoading = false;

  get hasDownload(): boolean {
    return !!this.invoice.Bucket && !!this.invoice.Key && !!this.invoice.Id;
  }

  async download() {
    if (!this.s3Url) {
      await this.fetchS3Url();
    }
    (this.$refs['download-link'] as HTMLElement).click();
  }

  async fetchS3Url() {
    if (this.invoice.Id === undefined) {
      return;
    }
    try {
      this.isLoading = true;
      const configuration = await getConfiguration();
      const api = new InvoiceApi(configuration, '');
      const { data } = await api.invoiceDownloadLinkGet(this.invoice.Id);
      if (data.s3_url) {
        this.s3Url = data.s3_url;
      }
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      this.isLoading = false;
      setTimeout(() => {
        this.s3Url = '';
      }, 300 * 1000);
    }
  }
}
